<template>
  <div class="demo">
     <navInner></navInner>
     <div class="demoInner">
       <img src="~@/assets/image/de_pic.jpg" class="de_pic" />
       <img src="~@/assets/image/de_tit.png" class="de_tit wow fadeInUp" />
    </div>
  <siderBar></siderBar>
  
  </div>
</template>

<script>
  import Vue from 'vue'
  import { WOW } from 'wowjs'
  import siderBar from '@/components/siderBar.vue'
  import navInner from '@/components/navInner.vue'
  import { mapMutations, mapGetters, mapState } from 'vuex'
  import { Lazyload } from 'vant'
  import { Image as VanImage } from 'vant'
  Vue.use(VanImage)
  Vue.use(Lazyload)
  export default {
    data () {
      return {
        bgFlag: false,
        vdFlag: false,
        muneFlag: false,
        muneIndex: -1,
        mySwiper: null,
        moveFlag: false,
        goodsList: [],

      }
    },
    components: {siderBar, navInner},
    computed: {
      ...mapState(['langFlag', 'lang', 'title']),
    },
    mounted () {
      let that = this

      // 滚动条滚动
      window.addEventListener('scroll', this.handleScroll)
    // 在项目加载完成之后初始化wow
    this.$nextTick(() => {
      let wow = new WOW({
        live: false,
      })
      wow.init()
    })

    },

    watch: {
      langFlag (val) {
        console.log('中英文的值', val)
        this.projectCate()
        this.homeSwiper()
      },
      title (val) {
        document.title = val
      },
    },
    methods: {
      // ...mapMutations(['SET_WFFLAG']),

      //  视频播放
      toPlay () {
        this.vdFlag = true
        this.$refs.videoPlayer2.play()
        // this.$refs.videoPlayer.paused === true
        //   ? this.$refs.videoPlayer.play()
        //   : this.$refs.videoPlayer.pause()
      },
      toPause () {
        // this.$refs.videoPlayer.paused === true
        //   ? this.$refs.videoPlayer.pause()
        //   : this.$refs.videoPlayer.pause()
      },

      
    },
  }
</script>
<style>
  /* @import './../assets/css/base.css'; */
  .hvde video {
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
  }

  .hvde {
    position: relative;
    width: 100%;
    height: 100%;
  }

  .home_swiper .play_ico {
    position: absolute;
    left: 50%;
    width: 1rem !important;
    height: 1rem !important;
    margin: -0.5rem 0 0 -0.5rem;
    top: 50%;
    z-index: 10;
  }

  .hcom_tp .van-image__error-icon {
    min-height: 100px;
    font-size: 1rem;
  }
</style>


// WEBPACK FOOTER //
// src/pages/demo.vue